import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { feedback } from './feedback.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiUrl = `${environment.apiConfig.uri}/feedback`;
  
  constructor(private http: HttpClient) { }

    createFeedback(newFeedback: feedback): Observable<any> {
        return this.http.post(this.apiUrl, {
            feedbackBody: newFeedback.feedbackBody,
        });
    }
}
